/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
	Icon,
	VStack,
	IconButton,
	Flex,
	HStack,
	Input,
	InputGroup,
	InputRightElement,
	InputLeftElement,
	createIcon,
	Tag,
	TagLabel,
	TagCloseButton,
	Box,
	Image,
	chakra,
} from '@chakra-ui/react'
import React, { useEffect, useState, useCallback } from 'react'
import { debounce } from 'lodash'
import { MdClose, MdRefresh, MdSearch } from 'react-icons/md'
import { IoIosRefresh } from 'react-icons/io'
import { BiFilterAlt } from 'react-icons/bi'
import { useSharedContext } from '../../context/shared.context'
import ActivityListView from './activity-listing-view'
import QueueSetup from './queue-setup'
import StatusActivityTypeView from './status-activity-type-view'
import SortActivityTypeView from './sort-activity-type-view'
import CustomMenu from '../../components/menu'
import {
	defaultSortOption,
	SortOptionList,
} from '../../../src/containers/action-panel/activity-listing-view/sort.option'
import { getCurrentDateISTWidgetDash } from '../../utils/date.utils'
import { getCurrentDateUTC } from '../../utils/common.util'
import {
	useLoadActivityListV1,
	useLoadActivityListV2,
	useLoadFilterActivityList,
	useLoadFocusActivityList,
	useLoadChildOrderActivity,
	useLoadActivityFiletrListV1,
	useLoadFocusActivityListTagType,
} from '../../hooks/activity.hooks'
import { useAuthContext } from '../../context/auth.context'
import { useLanguageContext } from '../../context/locale.context'
import { sharedConst } from '../../utils/action.constant'
import {
	dataLayerTagManager,
	sectionDetailedTrack,
} from '../repository/repo.utils'
import { GA_CATEGORY_FILES } from './../repository/repo.utils'
import ButtonCTA from './../../components/globalComponents/button/index'
import SVGIcon from '../../assets/svgIcons'
import InputText from '../../components/globalComponents/inputText'
import { AiOutlineClose } from 'react-icons/ai'
import { useHistory } from 'react-router'
export const ACTION_PANEL_VIEW = {
	LIST_VIEW: 'LIST_VIEW',
	STATUS_TYPE_VIEW: 'STATUS_TYPE_VIEW',
	QUEUE_SETUP_VIEW: 'QUEUE_SETUP_VIEW',
	SORT_TYPE_VIEW: 'SORT_TYPE_VIEW',
}

const sortIcon = createIcon({
	displayName: 'Sort',
	viewBox: '0 0 10 16',
	d: 'M4.774 16c-.416.001-.81-.19-1.065-.518L.288 11.125a1.357 1.357 0 011.065-2.19H8.19a1.354 1.354 0 011.065 2.19L5.84 15.482c-.256.328-.65.52-1.066.518zm-3.42-6.327a.614.614 0 00-.485 1l3.422 4.353a.633.633 0 00.966 0l3.423-4.361a.617.617 0 00-.485-1l-6.842.008zM8.195 7.037H1.36a1.354 1.354 0 01-1.072-2.19L3.709.495a1.394 1.394 0 012.13 0l3.422 4.352a1.356 1.356 0 01-1.065 2.19zM4.775.71a.609.609 0 00-.484.235L.87 5.301a.616.616 0 00.484 1H8.19a.616.616 0 00.485-1L5.258.945A.609.609 0 004.774.71z',
})

export const ActionPanel = ({ openFormView, openActivityView, queue }) => {
	const {
		state: { filter, view, isFirst, isReloadList },
		dispatch,
	} = useSharedContext()
	const {
		state: { authData },
	} = useAuthContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const [selectedFilter, setSelectedFilter] = useState({})
	const [selectedQueue, setSelectedQueue] = useState({})
	const [selectedStatus, setSelectedStatus] = useState({})
	const [statusIndex, setStatusIndex] = useState({ cat: 0, sub_cat: null })
	const [searchQuery, setSearchQuery] = useState('')

	const [selectedSort, setselectedSort] = useState(() => {
		return defaultSortOption(locale, queue)
	})
	const [data, setdata] = useState({})
	const [isLoading, setIsLoading] = useState(false)
	const [isRefresh, setIsRefresh] = useState(false)
	const [isBtnLoading, setIsBtnLoading] = useState(false)
	const [activity, setActivity] = useState({})
	const [isChildActive, setChildActive] = useState(false)
	const [child_title, setChildOrderTitle] = useState('')
	const [reqSearch, setReqSearch] = useState(false)

	const { mutate: activityListV1Mutate } = useLoadActivityListV1()
	const { mutate: activityFiletrListV1 } = useLoadActivityFiletrListV1()
	const { mutate: activityListV2Mutate } = useLoadActivityListV2()
	const { mutate: focusListMutate } = useLoadFocusActivityList()
	const { mutate: focusListMutateTagType } = useLoadFocusActivityListTagType()
	const { mutate: filterListMutate } = useLoadFilterActivityList()
	const { mutate: activityChildOrderListMutate } = useLoadChildOrderActivity()

	const [panelView, setpanelView] = useState(ACTION_PANEL_VIEW.LIST_VIEW)

	// Staging code
	// const [panelView, setpanelView] = useState(ACTION_PANEL_VIEW.QUEUE_SETUP_VIEW)
	const { organization_flag_enable_tag } = authData
	const history = useHistory()

	useEffect(() => {
		setSelectedFilter(filter || {})
		setSelectedQueue(queue || {})
		setpanelView(view || ACTION_PANEL_VIEW.LIST_VIEW)
		// Staging code
		// setpanelView(view || ACTION_PANEL_VIEW.QUEUE_SETUP_VIEW)
		if (!!isFirst) {
			openActivityView()
		}
	}, [filter, queue, view, isFirst])

	useEffect(() => {
		setselectedSort(defaultSortOption(locale, queue))
	}, [queue])

	useEffect(() => {
		setSearchQuery('')
		loadActivity({
			searchQuery,
			selectedSort,
			selectedStatus,
		})
	}, [selectedFilter, selectedQueue, selectedStatus, selectedSort])

	const onSuccess = (res, isChild = false, pagestart = 0) => {
		setIsLoading(false)
		setIsBtnLoading(false)
		// if (
		//   !!searchQuery ||
		//   !data ||
		//   !Object.keys(data).length ||
		//   (isChild && pagestart === 0) ||
		//   (isRefresh && pagestart === 0)
		// ) {
		if (pagestart === 0) {
			setdata(res)
		} else if (!!data && !!res) {
			const { list, ...rest } = res
			setdata({
				...rest,
				list: [...data.list, ...list],
			})
		}
	}

	const onError = err => {
		setIsLoading(false)
		setIsBtnLoading(false)
	}
	const loadActivity = ({
		start = 0,
		searchQuery = '',
		isRefresh = !!selectedQueue.isRefresh ? selectedQueue.isRefresh : false,
		selectedSort = SortOptionList(locale)[0],
		selectedStatus,
	}) => {
		let countFlag = 0

		if (
			!!selectedStatus?.activity_type_id ||
			!!selectedStatus?.activity_type_category_id ||
			!!selectedStatus?.activity_status_type_id
		) {
			countFlag = 1
		}

		setIsBtnLoading(true)
		setIsRefresh(false)
		if (!start) {
			setIsLoading(true)
		}
		if (isRefresh) {
			setIsRefresh(true)
		}
		if (Object.keys(selectedFilter).length > 0) {
			filterListMutate(
				{
					isElasticSearchEnabled:
						authData.organization_flag_elasticsearch_enabled,
					workforce_id: 0,
					search_string: searchQuery || '',
					flag_status: 0,
					flag_participating: 2,
					device_os_id: 5,
					page_limit: 50,
					page_start: start,
					activity_type_category_id: selectedFilter.activity_type_category_id, // TODO: send the category id from listing process type
					activity_type_id: selectedFilter?.activity_type_id || 0,
					tag_id: 0,
					tag_type_id: 0,
					activity_status_type_id: 0,
					sort_flag: selectedSort.value || 0,
				},
				{
					onSuccess: res => {
						if (res) {
							onSuccess(res, false, start)
						}
					},
					onError,
				}
			)
		} else if (Object.keys(selectedQueue).length > 0) {
			if (!selectedQueue.isStatic) {
				activityListV2Mutate(
					{
						page_start: start,
						page_limit: 30,
						sort_flag: selectedSort.value || 0,
						flag: 0,
						queue_id: selectedQueue.queue_id,
						is_active: 0,
						is_due: 0,
						current_datetime: getCurrentDateISTWidgetDash(),
						is_unread: 0,
						is_search: !!searchQuery ? 1 : 0,
						search_string: searchQuery || '',
						status_type_id: 0,
					},
					{
						onSuccess: res => {
							onSuccess(res, false, start)
						},
						onError,
					}
				)
			} else if (
				!!['MY_QUEUE', 'MENTIONS', 'DELAYED', 'UNREAD'].includes(
					selectedQueue.queue_id
				)
			) {
				let params = {}
				if (!!selectedStatus && Object.keys(selectedStatus).length > 0) {
					if (
						organization_flag_enable_tag === 1 &&
						selectedStatus.tag_id === 0
					) {
						params = {
							tag_id: selectedStatus.tag_id,
							tag_type_id: selectedStatus.tag_type_id || 0,
							activity_type_category_id: 0,
							activity_status_id: 0,
							activity_type_id: 0,
							is_count_flag: 0,
						}
					} else {
						params = {
							activity_status_id: selectedStatus?.activity_status_id,
							activity_type_id: selectedStatus?.activity_type_id || 0,
							activity_type_category_id:
								selectedStatus?.activity_type_category_id || 0,
							is_count_flag: countFlag,
						}
					}

					params = {
						...params,
						flag: selectedQueue.flag || 0,
						flag_asset_filter: selectedStatus?.radio_button_id || 0,
					}

					activityFiletrListV1(
						{
							sort_flag: selectedSort.value || 0,
							flag: selectedQueue.flag || 0,
							queue_id: 0,
							is_active: !!searchQuery ? 1 : 0,
							is_due: 0,
							current_datetime: '',
							is_unread: 0,
							is_search: !!searchQuery ? 1 : 0,
							search_string: searchQuery || '',
							status_type_id: 0,
							page_start: start,
							page_limit: 30,
							tag_id: 0,
							tag_type_id: 0,
							parent_activity_id: 0,

							...params,
						},
						{
							onSuccess: res => {
								onSuccess(res, false, start)
							},
							onError,
						}
					)
				} else {
					if (history.location.pathname !== '/focus') {
						activityFiletrListV1(
							{
								sort_flag: selectedSort.value || 0,
								flag: selectedQueue.flag || 0,
								queue_id: 0,
								is_active: !!searchQuery ? 1 : 0,
								is_due: 0,
								current_datetime: '',
								is_unread: 0,
								is_search: !!searchQuery ? 1 : 0,
								search_string: searchQuery || '',
								status_type_id: 0,
								page_start: start,
								page_limit: 30,
								tag_id: 0,
								tag_type_id: 0,
								parent_activity_id: 0,
								flag_asset_filter: 0,
								activity_status_id: 0,
								activity_type_id: 0,
								activity_type_category_id: 0,
								is_count_flag: 0,
								...params,
							},
							{
								onSuccess: res => {
									onSuccess(res, false, start)
								},
								onError,
							}
						)
					}
				}
			} else {
				let params = {}
				if (organization_flag_enable_tag === 1 && selectedStatus.tag_id === 0) {
					params = {
						tag_id: selectedStatus.tag_id,
						tag_type_id: selectedStatus.tag_type_id || 0,
						activity_type_category_id: 0,
						activity_status_id: 0,
						activity_type_id: 0,
						is_count_flag: 0,
					}
				} else {
					params = {
						activity_status_id: selectedStatus?.activity_status_id || 0,
						activity_type_id: selectedStatus?.activity_type_id || 0,
						activity_type_category_id:
							selectedStatus?.activity_type_category_id || 0,
						is_count_flag: countFlag,
					}
				}

				params = {
					...params,
					flag_asset_filter: selectedStatus?.radio_button_id || 0,
				}
				focusListMutateTagType(
					{
						account_id: 1102,
						datetime_start: '1970-01-01 00:00:00',
						datetime_end: getCurrentDateISTWidgetDash(),
						flag: 2,
						flag_search: !!searchQuery ? 1 : 0,
						search_string: searchQuery || '',
						sort_flag: 4,
						page_start: start,
						page_limit: 30,
						tag_type_id: 0,
						tag_id: 0,
						parent_activity_id: 0,
						flag_asset_filter: 0,
						activity_status_id: 0,
						activity_type_id: 0,
						activity_type_category_id: 0,
						is_count_flag: 0,
						...params,
					},
					{
						onSuccess: res => {
							onSuccess(res, false, start)
						},
						onError,
					}
				)
			}
		}
	}

	const onDebounceSearch = useCallback(
		debounce(e => {
			setdata(null)
			loadActivity({
				start: 1,
				searchQuery: e,
			})
			setSearchQuery(e)
		}, 500),
		[]
	)

	useEffect(() => {
		if (!data && !isLoading) {
			loadActivity({
				searchQuery,
				selectedSort,
				selectedStatus,
			})
		}
	}, [data])

	useEffect(() => {
		if (!!isReloadList) {
			setdata(null)
			dispatch({ type: sharedConst.RESET_REFRESH_LISTING })
		}
	}, [isReloadList])

	const loadChildActivities = useCallback((activity, page_start = 0) => {
		setIsLoading(page_start === 0 ? true : false)
		setIsBtnLoading(true)
		setChildActive(true)
		setChildOrderTitle(activity.activity_title)
		activityChildOrderListMutate(
			{
				parent_activity_id: activity.activity_id,
				page_start: page_start,
				page_limit: 30,
				startFrom: 0,
				sort_flag: 0,
				flag: 1,
				// flag: selectedQueue.queue_flag_show_child_workflows === 0 ? 1 : 3,
				datetime_end: getCurrentDateUTC(),
				datetime_start: '1970-01-01 00: 00: 00',
			},
			{
				onSuccess: res => {
					onSuccess(res, true, page_start)
				},
				onError,
			}
		)
	})

	const loadChildOrdersList = (activity, page_start = 0) => {
		loadChildActivities(activity, page_start)
		setActivity(activity)
	}

	const handleFilterClick = () => {
		dispatch({
			type: sharedConst.SET_SELECTED_QUEUE,
			queue,
			isFirst: false,
		})
		dispatch({
			type: sharedConst.SET_SELECTED_FILTER,
			filter: {},
		})
		dispatch({
			type: sharedConst.SET_ACTION_PANEL_VIEW,
			view: ACTION_PANEL_VIEW.STATUS_TYPE_VIEW,
		})
		setStatusIndex({ cat: 0, sub_cat: null })
		// setSelectedStatus({})
	}
	const handleSortClick = () => {
		dispatch({
			type: sharedConst.SET_SELECTED_QUEUE,
			queue,
			isFirst: false,
		})
		dispatch({
			type: sharedConst.SET_SELECTED_FILTER,
			filter: {},
		})
		dispatch({
			type: sharedConst.SET_ACTION_PANEL_VIEW,
			view: ACTION_PANEL_VIEW.SORT_TYPE_VIEW,
		})
		setStatusIndex({ cat: 0, sub_cat: null })
		// setSelectedStatus({})
	}

	const returnSelectedStatus = () => {
		if (Object.keys(selectedStatus).length > 0) {
			let statusName
			if (
				selectedStatus.tag_id === 0 &&
				selectedStatus.tag_type_id === null &&
				selectedStatus.activity_type_tag_id === null
			) {
				statusName = 'Others'
			} else if (selectedStatus?.activity_status_id !== 0) {
				statusName = selectedStatus.activity_status_name
			} else if (selectedStatus?.activity_type_id !== 0) {
				statusName = selectedStatus.activity_type_name
			} else if (selectedStatus.tag_id === 0) {
				statusName = selectedStatus.tag_type_name
			}
			return (
				<HStack w='100%' pl='1rem'>
					<Tag
						variant='solid'
						bg='yellow.600'
						fontSize='0.875rem'
						color='black'
						borderRadius='17px'
						h='1.75rem'
					>
						<TagLabel>{statusName || 'Others'}</TagLabel>
						<TagCloseButton
							onClick={() => {
								setStatusIndex({ cat: 0, sub_cat: null })
								setSelectedStatus({})
							}}
						/>
					</Tag>
				</HStack>
			)
		}
		return null
	}

	const returnSelectedSort = () => {
		if (Object.keys(selectedSort).length > 0) {
			let statusName = selectedSort?.label

			return (
				<HStack w='100%' pl='1rem'>
					<Tag
						variant='solid'
						bg='yellow.600'
						fontSize='0.875rem'
						color='black'
						borderRadius='17px'
						h='1.75rem'
					>
						<TagLabel>{`Sort by ${statusName}`}</TagLabel>
						<TagCloseButton
							onClick={() => {
								setStatusIndex({ cat: 0, sub_cat: null })
								setselectedSort({})
							}}
						/>
					</Tag>
				</HStack>
			)
		}
		return null
	}
	return (
		<VStack spacing={2} h='100%' bg='gray.500'>
			<Flex
				borderBottom='1px solid #E1E1E1'
				w='full'
				padding='1.25rem 1.5rem'
				alignItems='center'
			>
				{/* <Image src={greneIcon} maxH='0.625rem' display='inline-block' mb={0} /> */}
				<Box display={'inline-block'}>
					<SVGIcon
						iconName='GreenLogoLineSvg'
						svgProps={{
							width: '36',
							height: '10',
							viewBox: '0 0 36 10',
						}}
						// pathProps={{ fill: '#009B76' }}
					/>
				</Box>

				<chakra.span color='#000000' fontSize='16px' fontWeight={500}>
					&nbsp; {locale['Here is all requests']}
				</chakra.span>
				<IconButton
					className={`activity-listing-refresh-icon`}
					aria-label='Refresh'
					ml='auto'
					color='brand.700'
					size='sm'
					_focus={{
						bg: 'secondary',
					}}
					_hover={{
						bg: 'secondary',
					}}
					onClick={() => {
						sectionDetailedTrack({
							category: GA_CATEGORY_FILES,
							action: 'Refresh',
							label: 'Refresh Activities',
						})
						dataLayerTagManager('button_click', {
							viewName: 'Home',
							buttonName: 'Refresh',
						})
						setdata(null)
						setChildActive(false)
						setpanelView(ACTION_PANEL_VIEW.LIST_VIEW)
					}}
					icon={
						<SVGIcon
							iconName='RefreshSvg'
							svgProps={{
								width: '28',
								height: '28',
								viewBox: '0 0 28 28',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					}
				/>
			</Flex>
			{!reqSearch && (
				<Flex
					spacing={2}
					width='100%'
					justifyContent='flex-start'
					padding='1rem 1rem 0 1rem'
					flexBasis='3%'
					flexWrap='wrap'
					gap='0.5rem'
				>
					<ButtonCTA
						leftIcon={
							<Icon as={BiFilterAlt} color='brand.700' h='1rem' w='1rem' />
						}
						pl='0.75rem'
						pr='0.75rem'
						variant='sidebarButton'
						color='black'
						onClick={() => {
							handleFilterClick()
						}}
					>
						{locale['Filter']}
					</ButtonCTA>
					<ButtonCTA
						leftIcon={
							<Icon as={sortIcon} color='brand.700' h='1rem' w='1rem' />
						}
						pl='0.75rem'
						pr='0.75rem'
						variant='sidebarButton'
						color='black'
						onClick={() => {
							handleSortClick()
							sectionDetailedTrack({
								category: GA_CATEGORY_FILES,
								action: 'Refresh',
								label: 'Refresh Activities',
							})
							dataLayerTagManager('button_click', {
								viewName: 'Home',
								buttonName: 'Refresh',
							})
							setdata(null)
							setChildActive(false)
							// setpanelView(ACTION_PANEL_VIEW.LIST_VIEW)
						}}
					>
						{locale['Sort']}
					</ButtonCTA>
					<ButtonCTA
						pl='0.75rem'
						pr='0.75rem'
						variant='sidebarButton'
						color='black'
						onClick={() => setReqSearch(true)}
					>
						{locale['Search']}
					</ButtonCTA>
					{/* <CustomMenu
          optionList={SortOptionList(locale)
            .map(option => {
              if ('MY_FOCUS' === selectedQueue.queue_id) {
                if (option.key !== 'last-updated-date') {
                  return option
                }
              } else {
                return option
              }
            })
            .filter(Boolean)}
          selected={selectedSort}
          onSelect={item => {
            dataLayerTagManager('button_click', {
              viewName: 'Home',
              buttonName: 'Sort',
            })
            setselectedSort(item)
            setdata(null)
            dispatch({
              type: sharedConst.SET_ACTION_PANEL_VIEW,
              view: ACTION_PANEL_VIEW.LIST_VIEW,
            })
          }}
          leftIcon={<Icon as={sortIcon} color="brand.700" height="1rem" />}
          variant="sidebarButton"
          color="black"
          pl="0.75rem"
          pr="0.75rem"
          buttonText="Sort"
        /> */}
					<Box flexGrow='1'></Box>
					<ButtonCTA
						className={`action-panel-add-new-file-button`}
						id={`action-panel-btn-add-new-file`}
						variant='sidebarButton'
						// style={{ marginLeft: 'auto' }}
						pl='0.75rem'
						pr='0.75rem'
						onClick={() => {
							dataLayerTagManager('button_click', {
								viewName: 'Home',
								buttonName: 'Start Request',
							})
							openFormView()
						}}
						fontSize='0.75rem'
					>
						{locale['Start Request']}
					</ButtonCTA>
				</Flex>
			)}

			{reqSearch && (
				<InputGroup marginTop='2'>
					<InputText
						type='tel'
						width='100%'
						height='36px'
						fontSize='13px'
						fontStyle='normal'
						fontWeight='500'
						background='#FFFFFF'
						placeholder={locale['Request Name']}
						value={searchQuery}
						onChange={e => {
							dataLayerTagManager('button_click', {
								viewName: 'Home',
								buttonName: 'Smart Search',
							})
							setSearchQuery(e.target.value)
							onDebounceSearch(e.target.value)
							setpanelView(ACTION_PANEL_VIEW.LIST_VIEW)
						}}
						_placeholder={{
							color: '#5A5A5A',
						}}
						borderRadius='18px'
						border='none'
					/>
					<InputRightElement
						className={`status-activity-view-back-icon`}
						cursor='pointer'
						color='red.600'
						mb='2'
						onClick={() => {
							setReqSearch(false)
							sectionDetailedTrack({
								category: GA_CATEGORY_FILES,
								action: 'Search Query',
								label: 'List Activities',
							})
							setSearchQuery('')
							onDebounceSearch('')
							setpanelView(ACTION_PANEL_VIEW.LIST_VIEW)
						}}
						children={<AiOutlineClose fontSize={20} />}
					/>
				</InputGroup>
			)}
			{returnSelectedStatus()}
			{returnSelectedSort()}
			{panelView === ACTION_PANEL_VIEW.QUEUE_SETUP_VIEW ? (
				<QueueSetup
					setpanelView={setpanelView}
					selectedFilter={selectedFilter}
					setSelectedFilter={setSelectedFilter}
					selectedQueue={selectedQueue}
					setSelectedQueue={setSelectedQueue}
					setSelectedStatus={setSelectedStatus}
				/>
			) : panelView === ACTION_PANEL_VIEW.STATUS_TYPE_VIEW ? (
				<StatusActivityTypeView
					setpanelView={setpanelView}
					selectedFilter={selectedFilter}
					selectedQueue={selectedQueue}
					selectedStatus={selectedStatus}
					setSelectedStatus={setSelectedStatus}
					statusIndex={statusIndex}
					setStatusIndex={setStatusIndex}
					queue={queue}
				/>
			) : panelView === ACTION_PANEL_VIEW.SORT_TYPE_VIEW ? (
				<SortActivityTypeView
					setpanelView={setpanelView}
					selectedFilter={selectedFilter}
					selectedQueue={selectedQueue}
					selectedStatus={selectedStatus}
					setSelectedStatus={setSelectedStatus}
					statusIndex={statusIndex}
					setStatusIndex={setStatusIndex}
					setselectedSort={setselectedSort}
					queue={queue}
					optionList={SortOptionList(locale)
						.map(option => {
							if ('MY_FOCUS' === selectedQueue.queue_id) {
								if (option.key !== 'last-updated-date') {
									return option
								}
							} else {
								return option
							}
						})
						.filter(Boolean)}
					selected={selectedSort}
					onSelect={item => {
						dataLayerTagManager('button_click', {
							viewName: 'Home',
							buttonName: 'Sort',
						})
						setselectedSort(item)
						setdata(null)
						dispatch({
							type: sharedConst.SET_ACTION_PANEL_VIEW,
							view: ACTION_PANEL_VIEW.LIST_VIEW,
						})
					}}
					leftIcon={<Icon as={sortIcon} color='brand.700' height='1rem' />}
					variant='sidebarButton'
					color='black'
					pl='0.75rem'
					pr='0.75rem'
					buttonText='Sort'
				/>
			) : (
				<ActivityListView
					openActivityView={openActivityView}
					setpanelView={setpanelView}
					selectedFilter={selectedFilter}
					selectedQueue={selectedQueue}
					selectedStatus={selectedStatus}
					setStatusIndex={setStatusIndex}
					data={data}
					loadChildOrdersList={loadChildOrdersList}
					loadActivity={loadActivity}
					setdata={setdata}
					isChildActive={isChildActive}
					setChildActive={setChildActive}
					activity={activity}
					child_title={child_title}
					isLoading={isLoading}
					isBtnLoading={isBtnLoading}
					selectedSort={selectedSort}
					searchQuery={searchQuery}
				/>
			)}
		</VStack>
	)
}

export default ActionPanel
